import {
  Component,
  OnInit,
  OnChanges,
  OnDestroy,
  Input,
  Output,
  EventEmitter,
  ViewChild
} from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { NgForm, FormsModule, FormGroup, FormBuilder } from '@angular/forms';
import { MatSnackBar } from '@angular/material';
import {
  Ticket,
  TicketList,
  BluePrintTicket,
  Thread,
  Attachment,
  User,
  LoadingService,
  AuthenticationService,
  TicketService,
  TicketAttachmentService,
  CustomSnackbarComponent,
  SnackBarContent
} from '../../_shared';
import { Subscription } from 'rxjs/Rx';

declare const $: any;
@Component({
  selector: 'app-ticket-list',
  templateUrl: './ticket-list.component.html',
  styleUrls: [
    '../../../assets/css/core-navbar.css',
    '../../../assets/css/core-scrollbar.css',
    '../_css-ticket/ticket-content.css',
    './ticket-list.component.css',
    '../_css-ticket/ticket-content-mobile-responsive-filter.css'
  ]
})
export class TicketListComponent implements OnInit, OnChanges, OnDestroy {
  @Input() private tickets: Array<Ticket>;
  @Input() private hasRemainingTickets: boolean;
  @Input() private isShown: boolean;
  @Input() private currentUrlPath: string;
  // @Output()
  // private outputTicket: EventEmitter<BluePrintTicket> = new EventEmitter<
  //   BluePrintTicket
  // >();
  @Output() private refetch: EventEmitter<number> = new EventEmitter<number>();
  @ViewChild('attachfile') attachfile: any;

  public errorMessages = new Array<string>();
  public successMessage: string;

  private _hasRemainingTickets: boolean;
  private sum: number = 0;
  private limit: number = 10;
  private param: string;

  private data: any;
  private formData: FormData = new FormData();
  private dateNow: number;

  private newTicket: BluePrintTicket = new BluePrintTicket();
  private totalAttachmentSize = 0;
  private notifErrorModal = false;
  private notifSuccessModal = false;
  private isAttachmentUploaded = new Array<boolean>();
  private user: User = new User();
  private ticketid: string;
  private attachmentSubscriber: Subscription = new Subscription();

  private statusClass = ['', '', '', '', ''];
  private labelClass = ['', '', '', ''];
  private lastFetchTotal: number = 0;
  private selectedTicket: Ticket;
  private ticketsToBeShown: Ticket[] = null;
  private searchbar = 'sb-search';
  private refreshIntervalID: any;
  private filterOptions = {
    status: ['All', 'Open', 'Replied', 'Solved', 'Closed'],
    label: ['Blue', 'Green', 'Orange', 'Red']
  };

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private loadingService: LoadingService,
    private authenticationService: AuthenticationService,
    private ticketService: TicketService,
    private ticketAttachmentService: TicketAttachmentService,
    public snackBar: MatSnackBar
  ) {
    this.refreshIntervalID = setInterval(() => {
      this.dateNow = Date.now();
    }, 1000);
    // update date.now every sec
    this.createTicketModel();

    this.initCounters();
  }

  initCounters() {
    this.sum = 0;
    this.limit = 10;
    this.lastFetchTotal = 0;
    this._hasRemainingTickets = true;
  }

  onScrollDown() {
    if (this.hasRemainingTickets && this.ticketsToBeShown !== null) {
      this.sum += this.limit;
      this.refetch.emit(this.sum);
    }
  }

  ngOnInit() {
    this.authenticationService.userInfo.subscribe(res => {
      this.user = res;
      if (this.user.current_role.role_id === 'R5') {
        this.initializeModal();
      }
    });
    this.statusClass[0] = 'menu-active';

    // subscribe to param changes
    this.route.paramMap.subscribe(params => {
      this.param = params.get('id');
      console.log(this.param);
    });
    this.load(false);
  }

  ngOnChanges(changes: any) {
    console.log(changes);
    this.route.paramMap.subscribe(params => {
      this.param = params.get('id');
    });

    if (changes['hasRemainingTickets']) {
      if (typeof this.hasRemainingTickets !== 'undefined') {
        this._hasRemainingTickets = this.hasRemainingTickets;
      }
    }
    if (changes['tickets']) {
      // ticket list stream arrives
      this.ticketsToBeShown = this.tickets;

      // if the tickets on database has been fully loaded, disable trigger infinity scroll
      if (this.ticketsToBeShown !== undefined) {
        this._hasRemainingTickets = this.hasRemainingTickets;
      }
    }
  }

  ngOnDestroy() {
    clearInterval(this.refreshIntervalID);
  }

  changeLabel(i: number) {
    for (let index = 0; index < 4; index++) {
      this.labelClass[index] = '';
    }
    this.labelClass[i] = 'menu-active';
    this.ticketsToBeShown = this.tickets.filter(t => t.label === i + 1);
  }

  changeStatus(i: number, status: string) {
    this.selectedTicket = null;
    for (let index = 0; index < 5; index++) {
      this.statusClass[index] = '';
    }
    this.statusClass[i] = 'menu-active';
    this.ticketsToBeShown = this.tickets;
    if (status !== 'All') {
      this.ticketsToBeShown = this.ticketsToBeShown.filter(
        t => t.status === status
      );
    }
  }

  load(value: boolean) {
    this.loadingService.setLoadingState(value);
  }

  selectTicket(ticket: Ticket) {
    this.load(true);
    this.selectedTicket = ticket;
    // this.outputTicket.emit(ticket);
    this.navigateTo(ticket.ticket_id);
  }

  navigateTo(ticketId: string) {
    let path = this.currentUrlPath + '/detail/' + ticketId;
    this.router.navigate([path]);
  }

  searchToggle($event: any) {
    if ($event.target.className === 'sb-icon-search') {
      // open the search bar if it is not toggled
      this.searchbar = 'sb-search sb-search-open';
    }
  }

  Search(searchForm: NgForm) {
    // if the form is pristine or doesn't have any key, closes the search bar
    if (
      searchForm.form.pristine === true ||
      searchForm.value.searchkey === ''
    ) {
      this.searchbar = 'sb-search';
    } else {
      // submit search key
      console.log(searchForm.form);
    }
  }

  // ----------------- new ticket functions

  initializeModal() {
    this.newTicket.cust_id = this.user._id;
    this.newTicket.thread[0].created_by = this.user._id;

    this.ticketService.generateTicketId().then(id => {
      this.newTicket.ticket_id = id;
    });
  }

  createTicketModel() {
    this.newTicket.ticket_id = 'CP-YYYYMMDD-00001';
    this.newTicket.thread = [
      {
        created_at: null,
        created_by: null,
        message: '',
        attachments: []
      }
    ];
    this.newTicket.thread[0].attachments = [];
    this.newTicket.subject = '';
    this.newTicket.cust_id = '';
    this.newTicket.label = 0;
    this.newTicket.type = 'Support';
    this.newTicket.status = 'Open';
  }

  cancelTicket() {
    // remove all attachment + directory in server endpoint
    this.removeAttachmentDirectory(this.newTicket.ticket_id);

    // remove each attachments to formData
    this.formData.delete('attachment[]');

    // reset form
    this.createTicketModel();
    this.initializeModal();
  }

  removeAttachmentDirectory(ticketid: string) {
    this.ticketAttachmentService
      .removeAttachmentDirectory(ticketid)
      .subscribe(res => {
        console.log('remove dir', res);
      });
  }

  removeAttachmentInServer(i: number, hashedfilename: string) {
    if (hashedfilename !== null) {
      // hit api endpoint using service here
      this.ticketAttachmentService.removeAttachment(hashedfilename).subscribe(
        res => {},
        err => {},
        () => {
          // splice attachment status
          this.isAttachmentUploaded.splice(i, 1);

          // remove attachment in model
          this.newTicket.thread[0].attachments.splice(i, 1);
        }
      );
    }
  }

  openNotifModal(message: string) {
    this.errorMessages.push(message);
    this.notifErrorModal = true;
  }

  closeNotifModal() {
    this.notifErrorModal = false;
    this.notifSuccessModal = false;
    this.errorMessages = new Array<string>();
  }

  // listen to file change event in attach button and validate it
  fileChange(event: any, input: any) {
    const fileList: FileList = event.target.files; // get files from change event in browse button
    let validation = this.ticketAttachmentService.attachmentsValidation(
      fileList
    );
    if (validation.success) {
      this.appendAttachments(fileList, validation.data);
    } else {
      this.openNotifModal(validation.errors);
    }
    this.attachfile.nativeElement.value = '';
  }

  appendAttachments(fileList: FileList, type: string) {
    if (!this.formData.has('ticket_id')) {
      this.formData.append('ticket_id', this.newTicket.ticket_id);
    }
    let fileCount = fileList.length;
    for (let i = 0; i < fileCount; i++) {
      this.addAttachmentItem(fileList[i].name, type, fileList[i].size);
      // append each attachments to this.formData
      this.formData.append('attachment[]', fileList[i], fileList[i].name);
      this.formData.append('attachmentsize[]', fileList[i].size.toString());
      // set isAttachmentUploaded array into false
      this.isAttachmentUploaded.push(false);

      // add attachment in server
      this.addAttachmentInServer();
    }
  }

  addAttachmentInServer() {
    // hit api endpoint using service here
    let x = 0;
    this.attachmentSubscriber = this.ticketAttachmentService
      .uploadAttachment(this.formData)
      .subscribe(res => {
        for (let i = 0; i < this.newTicket.thread[0].attachments.length; i++) {
          if (this.newTicket.thread[0].attachments[i].hashedfilename == null) {
            this.newTicket.thread[0].attachments[i].hashedfilename =
              res.data[x];
            x++;

            // change isAttachmentUploaded into true
            this.isAttachmentUploaded.pop();
            this.isAttachmentUploaded.unshift(true);
          }
        }
      });

    // after posting data, reset the value in formData to avoid duplicate file upload
    this.formData.delete('attachment[]');
    this.formData.delete('attachmentsize[]');
  }

  dataHasErrors(message: string) {
    this.errorMessages.push(message);
    console.log(message);
    this.notifErrorModal = true;
  }

  addAttachmentItem(name: string, extension: string, size: number) {
    const attachment = new Attachment();
    attachment.filename = name;
    attachment.extension = extension;
    attachment.filesize = size;
    attachment.hashedfilename = null;

    this.newTicket.thread[0].attachments.push(attachment);
  }

  onSubmit() {
    this.load(true);
    console.log(this.newTicket);

    this.ticketService
      .addTicket(this.newTicket)
      .finally(() => {
        /* this function is executed when the observable ends (completes) its stream */
        console.log('Completed');
        this.load(false);
        if (this.data.success === true) {
          // show modal success
          this.successMessage = 'Ticket Successfully Created!';
          this.notifSuccessModal = true;

          // clear the field
          this.newTicket = new BluePrintTicket();
          $('#modalNew-Ticket').modal('hide');
          this.createTicketModel();
          this.initializeModal();
          this.refetch.emit(this.sum);
        } else {
          this.errorMessages = this.data.errors;
          this.notifErrorModal = true;
        }
      })
      .subscribe((res: any) => {
        this.data = res;
        console.log('VALUE RECEIVED: ', res);

        if (res.success) {
          let data: SnackBarContent = {
            type: 'success',
            message: 'New ticket has been created'
          };
          this.snackBar.openFromComponent(CustomSnackbarComponent, {
            data: data,
            duration: 5000
          });
        } else {
          let data: SnackBarContent = {
            type: 'error',
            message: 'Something went wrong'
          };
          this.snackBar.openFromComponent(CustomSnackbarComponent, {
            data: data,
            duration: 5000
          });
        }
      });
  }
}

@Component({
  selector: 'mat-spinner',
  templateUrl: 'ticket-list.component.html'
})
export class LoadingSpinnerList {}



// WEBPACK FOOTER //
// D:/Work-Local/frontend/src/app/ticket/ticket-list/ticket-list.component.ts